export const DS_URL_WE="https://discord.com/invite/AW6Zve7shj"
export const DS_URL_TVOK = "https://discord.gg/Wh6emGAD"
export const PASSWORD = "password"